import { RootState } from "../../store/store";
import { useSelector } from "react-redux";

const useRolePermissions = () => {
  const getRoles: any = useSelector((state: RootState) => state.auth.permission);
  const subscriptionData: any = useSelector((state: RootState) => state.auth.subscriptionData);
  const inventoryType = subscriptionData?.inventory_type;

  const isRoleAccess = (role: any): boolean => {
    let permissionsObj = getRoles?.permission;
    if (!permissionsObj || Object.keys(permissionsObj).length === 0) {
      try {
        const stored = localStorage.getItem("roles");
        if (stored) {
          permissionsObj = JSON.parse(stored);
        }
      } catch (e) {
        console.error("Error reading roles from localStorage", e);
      }
    }

    if (permissionsObj && typeof permissionsObj === "object") {
      const val = permissionsObj[role];
      if (val === "false" || val === false || val === 0 || val === "0" || val === null || val === undefined) {
        return false;
      }
      if (val === "true" || val === true || val === 1 || val === "1") {
        return true;
      }
      return Boolean(val);
    }
    return false; // Default to false (deny by default)
  };

  const hasPermissions = (role: any): boolean => {
    return isRoleAccess(role);
  };

  const isAssetInventory = () => {
    const type = inventoryType;

    if (!type) return 0; // no inventory_type → show both
    if (type === "cloud_resources") return 1;
    if (type === "on_prem_assets") return 2;

    return 0;
  };

  return {
    isRoleAccess,
    hasPermissions,
    isAssetInventory,
  };
};

export default useRolePermissions;